<template>
	<div class="content-wrapper">
		<div class="sf-flex-column h-100">
			<div class="sf-col sf-col-4">
				<sf-card class="p-0 h-100 card_bg">
					<cmpn-mst-search ref="cmpnMstSearch" :scrId="scrId"></cmpn-mst-search>
				</sf-card>
			</div>
			<div class="sf-col sf-col-20">
				<sf-card class="p-0 border-0 bg-transparent h-100">
					<cmpn-mst-table ref="table" @registerCmpn="registerCmpn" @Refresh="Refresh" :scrId="scrId"></cmpn-mst-table>
				</sf-card>
			</div>
			<!--캠페인 상세페이지 팝업창 영역 시작-->
			<cmpn-mst-popup :scrId="scrId" ref="cmpnMstPopup" @Refresh="Refresh"></cmpn-mst-popup>
			<!--캠페인 상세페이지 팝업창 영역 끝-->
		</div>
	</div>
</template>

<script>
import CmpnMstSearch from './Search/CmpnMstSearch.vue';
import CmpnMstTable from './Table/CmpnMstTable.vue';
import CmpnMstPopup from './Popup/CmpnMstPopup.vue';
import { rootComputed, rootMethods } from '@/store/common/helpers';
export default {
	props: {
		scrId: { type: String, default: '' }
	},
	components: { CmpnMstSearch, CmpnMstTable, CmpnMstPopup },
	computed: { ...rootComputed },
	methods: {
		...rootMethods,
		Refresh() {
			//$refs 는 컴포넌트에 ref로 정의한 이름으로 접근할때 사용한다.
			this.$refs.cmpnMstSearch.searchList();
		},
		registerCmpn(param) {
			this.$refs.cmpnMstPopup.open(param);
		}
	}
};
</script>

<style></style>
